<template>
  <div>
    <RangePicker :value="hackValue || text" :format="props.item.format || 'YYYY-MM-DD HH:mm:ss'"
      :value-format="props.item.format || 'YYYY-MM-DD HH:mm:ss'" :show-time="{
        defaultValue: props.item.defaultValue || [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
      }" @change="onChange" @openChange="onOpenChange" @calendarChange="onCalendarChange" :disabled-date="props.item.disabledDate || disabledDate" v-bind="{ ...(item.bindData || {})}">
    </RangePicker>
  </div>
</template>

<script setup lang='ts'>
import {
  RangePicker
} from 'ant-design-vue'
import { FormListItem } from '@tmp/site-common';
import { PropType, ref, computed } from 'vue'
import dayjs, { Dayjs } from 'dayjs';
type RangeValue = [any, any] | [Dayjs, Dayjs];
const emits = defineEmits(['update:value'])
const props = defineProps({
  item: { type: Object as PropType<Partial<FormListItem>>, default: {} as Partial<FormListItem> },
  searchParam: { type: Object, default: {} as Record<string, any> },
  value: {
    type: Array,
    required: true
  }
})
const text = computed({
  get() {
    return props.value as any;
  },
  set(newValue) {
    emits('update:value', newValue);
  }
})

const dates = ref<RangeValue>();
const hackValue = ref<RangeValue>();
const disabledDate = (current: Dayjs) => {
  const flag = (current && current > dayjs().endOf('day')) || (current && current < dayjs().subtract(props.item.limitDay || 180, 'day'))
  if (!dates.value || (dates.value as any).length === 0) {
    return flag
  }
  if (props.item.maxDate) {
    const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > props.item.maxDate - 1 || flag;
    const tooEarly = dates.value[1] && (dayjs(dates.value[1]).diff(current, 'days') > props.item.maxDate || flag);
    return tooEarly || tooLate;
  }
  return flag;
};

const onOpenChange = (open: boolean) => {
  if (open) {
    dates.value = [] as any;
    hackValue.value = [] as any;
  } else {
    hackValue.value = undefined;
  }
};

const onChange = (val: RangeValue, dateString: [string, string]) => {
  text.value = val;
  if (props.item.realField) {
    props.item.realField.forEach((_, i) => {
      props.searchParam[_] = val ? val[i] : ''
    })
  }
};

const onCalendarChange = (val: RangeValue) => {
  dates.value = val;

};


</script>
<style scoped lang='scss'></style>